import {ReactChild} from 'react';
import styled, {DefaultTheme, StyledComponentProps} from 'styled-components';
import styledMap from 'styled-map';
import {ifProp} from 'styled-tools';

export type HelperProps = StyledComponentProps<
  'span',
  DefaultTheme,
  {
    children?: string | ReactChild;
    weight?: number;
    state?: 'error' | 'warning' | 'default' | 'success' | 'performance';
  },
  never
>;

const color = ({state = 'default', theme}: any) => {
  switch (state) {
    case 'error':
      return theme.colors.red400;
    case 'warning':
      return theme.colors.orange300;
    case 'success':
      return theme.colors.green400;
    default:
      return theme.colors.textMedium;
  }
};

export const Helper = styled.span<HelperProps>`
  color: ${color};
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  margin-top: 5px;
  /* position: absolute; */
  bottom: 20px;
  bottom: -20px;
  display: ${ifProp('children', 'block', 'none')};
`;
export const SecondaryHelper = styled.span<HelperProps>`
  color: ${color};
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  margin-top: 5px;
  /* position: absolute; */
  bottom: 20px;
  bottom: -20px;
  display: ${ifProp('children', 'block', 'none')};
`;
